import PropTypes from "prop-types";
import { Stack } from "@mui/material";
import { TopNavItem } from "./top-nav-item";
import { isNavPathExact, isNavPathPartial } from "../nav-path-match";

export const TopNavSection = (props) => {
  const { items = [], pathname } = props;

  return (
    <Stack
      component="ul"
      direction="row"
      spacing={1}
      sx={{
        listStyle: "none",
        m: 0,
        p: 0,
      }}
    >
      {items.map((item) => {
        const checkPath = !!(item.path && pathname);
        const partialMatch = checkPath ? isNavPathPartial(pathname, item.path) : false;
        const exactMatch = checkPath ? isNavPathExact(pathname, item.path) : false;

        // Branch

        if (item.items) {
          return (
            <TopNavItem
              active={partialMatch || item.items.some((child) => isNavPathPartial(pathname, child.path))}
              disabled={item.disabled}
              icon={item.icon}
              items={item.items}
              key={item.title}
              label={item.label}
              path={item.path}
              title={item.title}
            />
          );
        }

        // Leaf

        return (
          <TopNavItem
            active={exactMatch}
            disabled={item.disabled}
            external={item.external}
            icon={item.icon}
            key={item.title}
            label={item.label}
            path={item.path}
            title={item.title}
          />
        );
      })}
    </Stack>
  );
};

TopNavSection.propTypes = {
  items: PropTypes.array,
  pathname: PropTypes.string,
  subheader: PropTypes.string,
};
